import { AlertTriangle, ExternalLink } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";

export function FirebaseSetupRequired() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800 p-4">
      <Card className="w-full max-w-lg">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
            <AlertTriangle className="h-6 w-6 text-white" />
          </div>
          <CardTitle className="text-2xl font-bold">Firebase Setup Required</CardTitle>
          <CardDescription>
            Please configure Firebase to use authentication features
          </CardDescription>
        </CardHeader>
        
        <CardContent className="space-y-4">
          <Alert>
            <AlertTriangle className="h-4 w-4" />
            <AlertDescription>
              Firebase configuration is missing or invalid. The app requires proper Firebase setup to function.
            </AlertDescription>
          </Alert>

          <div className="space-y-3">
            <h3 className="font-semibold">Quick Setup Steps:</h3>
            <ol className="text-sm space-y-2 list-decimal list-inside text-muted-foreground">
              <li>Create a Firebase project at <code>console.firebase.google.com</code></li>
              <li>Enable Authentication with Phone provider</li>
              <li>Copy your Firebase config to <code>.env</code> file</li>
              <li>Restart the development server</li>
            </ol>
          </div>

          <Button
            className="w-full"
            onClick={() => window.open('https://console.firebase.google.com', '_blank')}
          >
            <ExternalLink className="mr-2 h-4 w-4" />
            Open Firebase Console
          </Button>

          <div className="text-center">
            <p className="text-sm text-muted-foreground">
              See <code>FIREBASE_SETUP.md</code> for detailed instructions
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
} 